import _ from "lodash";
import { CategoryDto } from "../../common/service/server/dto/datamap/DataMapDto";
const collator = new Intl.Collator(undefined, { numeric: true, caseFirst: "lower" });

export function by_keys(...keys) {
  return (objA, objB) => {
    for (const key of keys) {
      const res = collator.compare(_.get(objA, key), _.get(objB, key));
      if (res) return res;
    }
    return 0;
  };
}

export const picSorter = (a: CategoryDto, b: CategoryDto): number => {
  if (a.picGroupId == b.picGroupId) {
    return a.order - b.order;
  } else {
    return a.picGroupOrder - b.picGroupOrder;
  }
};

export const employmentPicSorter = (a: CategoryDto, b: CategoryDto): number => {
  if (a.picGroupId == b.picGroupId) {
    return a.order - b.order;
  } else {
    return a.picGroupEmployeeOrder - b.picGroupEmployeeOrder;
  }
};

export const nullLocalCompare = (a: string | null | undefined, b: string | null | undefined) => {
  if (!a && !b) {
    return 0;
  }
  if (!a) {
    return -1;
  }
  if (!b) {
    return 1;
  }

  return a.localeCompare(b);
};
